import React from 'react';
import {Form, Modal} from "react-bootstrap";
import TextEditor from '../../components/TextEditor';
import {Controller, useForm} from "react-hook-form";
import {useAddBrokerMutation, useEditBrokerMutation} from "../../redux/services/BrokerService";
import {sweetAlert} from "../../utils";
import {responseError} from "../../helpers/responseHandler";
import LoadingButtonWithForm from "../../components/LoadingButtonWithForm";

const AddCompanyModal = ({isEdit, show, handleClose}) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: {errors},
    } = useForm()


    const [addRequest, {isLoading: addLoading}] = useAddBrokerMutation()
    const [editRequest, {isLoading: editLoading}] = useEditBrokerMutation()

    const onSubmit = async (data) => {
        console.log('data', data)
        // if (isEdit) {
        //     const newForm = {...data}
        //     await editRequest({id: isEdit?.id, newForm}).unwrap()
        //         .then((res) => {
        //             if (res?.status) {
        //                 sweetAlert(res?.message, 'success')
        //                 // navigate(-1)
        //                 handleClose()
        //             }
        //         })
        //         .catch((err) => {
        //             responseError(err)
        //         })
        // } else {
        //     const newForm = {...data}
        //     await addRequest(newForm).unwrap()
        //         .then((res) => {
        //             if (res?.status) {
        //                 sweetAlert(res?.message, 'success')
        //                 // navigate(-1)
        //                 handleClose()
        //             }
        //         })
        //         .catch((err) => {
        //             responseError(err)
        //         })
        // }
    }


    return (
        <>
            <Modal show={show} size="lg" onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">New Message Template</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='broker-status'>
                        <div className="row">
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Template Name:</Form.Label>
                                    <Controller
                                        name="template_name"
                                        control={control}
                                        defaultValue={isEdit?.template_name || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Select
                                                {...field}
                                                type="text"
                                                isInvalid={errors?.template_name}
                                            >
                                                <option value="">Please Select</option>
                                                <option value="notification email">Notification Email</option>
                                                <option value="job email">Job Email</option>
                                            </Form.Select>
                                        )}
                                    />

                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Subject:</Form.Label>
                                    <Controller
                                        name="subject"
                                        control={control}
                                        defaultValue={isEdit?.subject || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                placeholder="Enter Subject"
                                                isInvalid={errors?.subject}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Body:</Form.Label>
                                    <Controller
                                        name="body_content"
                                        control={control}
                                        defaultValue={isEdit?.body_content || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <TextEditor
                                                field={field}
                                                placeholder="Enter Body Content"
                                                isInvalid={errors?.body_content}
                                                onEditorChange={(content, editor) => {
                                                    setValue('body_content', content)
                                                }}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <LoadingButtonWithForm
                            isLoading={editLoading ? editLoading : addLoading}
                            name="Save"
                            form="broker-status"
                        />
                    </Form>
                </Modal.Body>

            </Modal>
        </>
    );
};

export default AddCompanyModal;